import { Box, Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import Icon from "@mui/material/Icon";

import { getStatus } from "./Calendar/Event";

const beeps = [
  {
    id: "beepScheduled",
    reminderForScheduledBeepId: 0,
    sentTime: false,
    resultReceivedTime: false,
  },
  {
    id: "beepSent",
    reminderForScheduledBeepId: 0,
    sentTime: true,
    resultReceivedTime: false,
  },
  {
    id: "beepCompleted",
    reminderForScheduledBeepId: 0,
    sentTime: true,
    resultReceivedTime: true,
  },
];

const reminders = [
  {
    id: "reminderScheduled",
    reminderForScheduledBeepId: 1,
    sentTime: false,
    resultReceivedTime: false,
  },
  {
    id: "reminderSent",
    reminderForScheduledBeepId: 1,
    sentTime: true,
    resultReceivedTime: false,
  },
  {
    id: "reminderCompleted",
    reminderForScheduledBeepId: 1,
    sentTime: true,
    resultReceivedTime: true,
  },
];

export default function Legend() {
  const { t } = useTranslation();
  const getList = (list) =>
    list.map((item) => (
      <Grid key={item.id} item xs={12} display={"flex"}>
        <Icon
          sx={{
            width: "18px",
            height: "18px",
            marginRight: "6px",
            color: "primary.main",
          }}
          component={
            getStatus({
              t,
              ...item,
            }).icon
          }
        />
        <Typography variant="body2">
          {getStatus({ t, ...item }).title}
        </Typography>
      </Grid>
    ));

  return (
    <Box>
      <Typography variant="subtitle2">
        {t("scheduler.calendar.beep")}
      </Typography>
      <Box p={0.5} />
      <Grid container spacing={1}>
        {getList(beeps)}
      </Grid>
      <Box p={1} />
      <Typography variant="subtitle2">
        {" "}
        {t("scheduler.calendar.reminder")}
      </Typography>
      <Box p={0.5} />
      <Grid container spacing={1}>
        {getList(reminders)}
      </Grid>
    </Box>
  );
}
